<template>
  <div :style="{paddingTop: top?'10px':0}">
    <!-- locationAddress -->
    <ScreenSort @changeobj="changeobj" :config="['enterpriseType','locationAddress','laborScreen']" laborAddress='true'></ScreenSort>
    <!-- 劳务公司列表页 -->
    <div class="table" v-loading="loadingTrue">
      <div style="padding: 0 20px 10px 20px">
        <el-row :gutter="20" v-if="teamList.length">
          <el-col v-for="(item, index) in teamList" :span="12" :key="index">
            <card :item="item" :type="1"></card>
          </el-col>
          <template v-if="param.page>=1">
            <el-col :span="24" class="course-loading-wrap" v-show="moreLoading">
              数据加载中... <i class="el-icon-loading loading-icon"></i>
            </el-col>
            <el-col :span="24" class="course-loading-wrap" v-show="!moreLoading && nomore">没有更多数据了!</el-col>
          </template>
        </el-row>

        <div v-if="!teamList.length && !loadingTrue" style="width: 1200px; margin: 0 auto; margin-bottom: 10px">
          <BaseEmptyData></BaseEmptyData>
        </div>
      </div>
    </div>
    <!-- <Pagination
      v-if="param.total>0 && !loadingTrue"
      :param="param"
      @change="teamInfoSearchList"
      :loadingTrue="loadingTrue"
    ></Pagination> -->
  </div>
</template>

<script>
import { apiLaborServiceCompany } from "@/api/apiLaborServiceCompany"
const throttle = require("lodash/throttle");
export default {
  name: "LaborServiceCompany",
  components: {
    ScreenSort: () =>import("@/components/screenSort/screenSort"),
    Pagination: () => import("@/components/card/page"),
    BaseEmptyData: () => import("@/components/public/BaseEmptyData"),
    card:() => import("@/components/card/cardLaborServiceCompany.vue")
  },
  props: {
    top: {
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
      teamList: [],
      loadingTrue: true,
      moreLoading: false, //加载更多
      nomore: false, //没有数据显示
      params:{},
      param:{
        page:1,
        limit:40,
        total:0,
        totalPages: 0
      },
    }
  },
  watch: {
    // 页数改变的时候
    "param.page": {
      handler(val) {
        if (val > this.param.totalPages) {
          this.nomore = true;
        } else {
          this.nomore = false;
        }
      },
    },
  },
  // 方法
  methods: {
    /** @name 获取列表筛选数据 */
    teamInfoSearchList() {
      this.moreLoading = true //加载更多显示
      let params={...this.params}
      params.page=this.param.page
      params.limit=this.param.limit
      if(process.env.VUE_APP_NAME ==="production"){
        params.profile='pro'
        params.serviceTypeNos=['1381524963651096576']
      }else if(process.env.VUE_APP_NAME==='pre'){
        params.profile='pro'
        params.serviceTypeNos=['1381524963651096576']
      }else if(process.env.VUE_APP_NAME==='development'){
        params.profile='dev'
        params.serviceTypeNos=['223']
      }
      apiLaborServiceCompany.getserviceCompany(params).then(res => {
        this.loadingTrue = false //初次进来页面加载状态隐藏
        if(res){
          if (res.data && res.data.code  === 200) {
            this.param.total  = res.data.data.total
            this.teamList = [...this.teamList,...res.data.data.records]
            this.param.totalPages=res.data.data.pages;
            this.moreLoading = false //加载更多隐藏
          }
        }
        this.loadingTrue = false
      })
    },
     // 页面滚动
    windowScroll: throttle(
      function () {
        // 如果当前页数大于总页数 则不去获取
        let scrollTop =
          document.documentElement.scrollTop ||
          window.pageYOffset ||
          document.body.scrollTop;
        let scrollHeight =
          document.documentElement.scrollHeight || document.body.scrollHeight;
        let clientHeight =
          document.documentElement.clientHeight || document.body.clientHeight;
        /**
         * clientHeight 视口大小
         * scrollHeight 文档高度
         */
        if (scrollTop + clientHeight >= scrollHeight - 300) {
          this.param.page += 1;
          if (this.param.page <= this.param.totalPages) {
            this.teamInfoSearchList()
          }
        }
      },
      1500,
      { leading: false, trailing: true }
    ),
    changeobj(obj){
      this.param.page=1
      this.teamList=[];
      this.loadingTrue = true 
      for(let i in this.params){
        this.params[i]=''
      }
      this.params.provinceNo=obj.locationAddresscode.provinceId;
      this.params.cityNo=obj.locationAddress?obj.locationAddresscode.cityId:'';
      this.params.areaNoList=obj.locationAddress?obj.locationAddress.map(v=>{return v.no}):[];
      if(obj.locationAddresscode.isAll){
        this.params.areaNoList=this.params.areaNoList[0]
      }
      this.params.companyType=obj.enterpriseType&&obj.enterpriseType[0]?obj.enterpriseType[0].label:''
      if(obj.laborScreen){
        obj.laborScreen.map(v=>{
          if(v.key=='workersize')this.params.workerNum=v.name
          if(v.key=='qualification')this.params.qualificationTypeNo=v.no
        })
      }
      this.teamInfoSearchList();
    }
  },
  mounted(){
    document.addEventListener("scroll", this.windowScroll);
  },
   beforeDestroy() {
    document.removeEventListener("scroll", this.windowScroll);
  },
}
</script>
<style lang="scss" scoped>
.table {
  position: relative;
  width: 1200px;
  margin: 10px auto 0;
  overflow: hidden;
  min-height: 400px;
  background: white;
  /deep/ .hideBox{
    display: none !important;
  }
}
.course-loading-wrap {
    display: flex;
    padding-top: 10px;
    font-size: 14px;
    align-items: center;
    justify-content: center;
    color: #999;
    background: #fff;
    font-size: 14px;
    .loading-icon {
      margin-left: 12px;
      font-size: 24px;
    }
  }
</style>
